module.exports = __webpack_public_path__ + "static/media/tongdao.483aa6c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/tongdao.mp3
// module id = qGFr
// module chunks = 208